(function ($) {
  "use strict";

  function wirePopover($trigger) {
    /* ------------------------------------------------------------
     * 1.  Resolve the slug once  (“store-3”, “store-7”…)
     * ---------------------------------------------------------- */
    const slug = $trigger.data("cardid") || $trigger.attr("id");
    if (!slug) return;

    const $card = $("#" + slug); // POI <g> inside SVG
    const $link = $(".location-map." + slug); // matching <h3> in the list
    if (!$card.length || !$link.length) return;

    const anchorEl =
      $card.find("path, rect, circle, ellipse, polygon")[0] || $card[0];
    /*  Cache each pin's "base" transform once */
    /* ------------------------------------------------------------
     * 2.  One Bootstrap popover per card (unchanged)
     * ---------------------------------------------------------- */
    const pop = bootstrap.Popover.getOrCreateInstance($card[0], {
      trigger: "manual",
      placement: "bottom",
      container: "body",
      html: true,
      content: $trigger.attr("data-bs-content") || "",
      template:
        '<div class="popover store-popover" role="tooltip"><div class="popover-body"></div></div>',
    });

    const base = $card.data("base-transform") || $card.attr("transform") || "";

    /* ------------------------------------------------------------
     * 3.  Hide logic with cancel-able timer (unchanged)
     * ---------------------------------------------------------- */
    let hideTimer = null;

    function cancelHide() {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    }

    function scheduleHide() {
      cancelHide();
      hideTimer = setTimeout(() => {
        // Check if mouse is still over trigger or popover using mouseenter/mouseleave flags
        if (!$trigger.data('hovered') && !$(pop.tip).data('hovered')) {
          $card.attr("transform", base); // restore exactly what was there
          pop.hide();
          $link.removeClass("is-map-hover");
        }
      }, 120);
    }

    /* ------------------------------------------------------------
     * 4.  Wires
     * ---------------------------------------------------------- */
    $trigger
      /* mouse-enter over the SVG hotspot ----------------------- */
      .on("mouseenter", () => {
        $trigger.data('hovered', true);
        
        /* 1 – clear any previous active link, pin and popover */
        $(".location-map.is-map-hover").removeClass("is-map-hover"); // old links
        $(".store-popover.show").each(function () {
          // old pops
          const inst = bootstrap.Popover.getInstance(this);
          if (inst) inst.hide();
        });
        cancelHide();
        $card.attr(
          "transform",
          base + " scale(1.1) translate(0 -11)" // keep the old, add your effect
        );
        $link.addClass("is-map-hover");
        
        /* 2 – scroll to the highlighted item if not in view */
        const $scrollContainer = $link.closest('.locations, .locations-mobile');
        if ($scrollContainer.length && $link.length) {
          const containerTop = $scrollContainer.scrollTop();
          const containerHeight = $scrollContainer.height();
          
          // Get the item's position relative to the scroll container
          const itemOffset = $link.offset().top - $scrollContainer.offset().top + $scrollContainer.scrollTop();
          const itemHeight = $link.outerHeight();
          
          // Account for any content above the list (like description text)
          const $description = $scrollContainer.find('.visit-description');
          const descriptionHeight = $description.length ? $description.outerHeight() : 0;
          
          // Calculate visible area (excluding description)
          const visibleStart = containerTop + descriptionHeight;
          const visibleEnd = containerTop + containerHeight;
          
          // Check if item is not fully visible in the scrollable area
          if (itemOffset < visibleStart || itemOffset + itemHeight > visibleEnd) {
            // Scroll to center the item in the visible area
            const scrollTo = itemOffset - descriptionHeight - (containerHeight - descriptionHeight) / 2 + itemHeight / 2;
            $scrollContainer.animate({
              scrollTop: Math.max(0, scrollTo)
            }, 300);
          }
        }
        
        pop.show();

        /* listeners on the popover node (exists only after show) */
        $(pop.tip)
          .off(".persist") // remove any old ones
          .on("mouseenter.persist", () => {
            $(pop.tip).data('hovered', true);
            cancelHide();
          })
          .on("mouseleave.persist", () => {
            $(pop.tip).data('hovered', false);
            scheduleHide();
          });
      })

      /* mouse-leave from the SVG hotspot ----------------------- */
      .on("mouseleave", () => {
        $trigger.data('hovered', false);
        scheduleHide();
      });
  }

  /* Mobile click handler for scrolling to list items */
  function handleMobileClick($trigger) {
    const slug = $trigger.data("cardid") || $trigger.attr("id");
    if (!slug) return;

    // Find the corresponding mobile list item
    const $mobileLink = $(".locations-mobile .location-map." + slug);
    const $mobileContainer = $('.locations-mobile');
    
    if ($mobileContainer.length && $mobileLink.length && $mobileContainer.is(':visible')) {
      // Clear any previous highlighting
      $(".location-map.is-map-active").removeClass("is-map-active");
      
      // Highlight the clicked item in mobile list
      $mobileLink.addClass("is-map-active");
      
      // Calculate scroll position for mobile container
      const containerTop = $mobileContainer.scrollTop();
      const containerHeight = $mobileContainer.height();
      
      // Get the item's position relative to the mobile scroll container
      const itemOffset = $mobileLink.offset().top - $mobileContainer.offset().top + $mobileContainer.scrollTop();
      const itemHeight = $mobileLink.outerHeight();
      
      // Check if item is not fully visible
      if (itemOffset < containerTop || itemOffset + itemHeight > containerTop + containerHeight) {
        // Scroll to center the item in the container
        const scrollTo = itemOffset - (containerHeight / 2) + (itemHeight / 2);
        $mobileContainer.animate({
          scrollTop: Math.max(0, scrollTo)
        }, 400);
      }
      
      // Remove highlight after a delay
      setTimeout(() => {
        $mobileLink.removeClass("is-map-active");
      }, 2000);
    }
  }

  /* attach to every hotspot */
  $(".point-link, .point").each(function () {
    wirePopover($(this));
    
    // Add mobile click handler
    $(this).on("click touchend", function(e) {
      // Only handle on mobile (when mobile container is visible)
      if ($('.locations-mobile').is(':visible')) {
        e.preventDefault();
        handleMobileClick($(this));
      }
    });
  });
})(jQuery);
